import { createStore } from '@servicetitan/financing-utils-shared';
import { useCallback, useState } from 'react';

function useReviewingFooter() {
    const [showApprovedFooter, setShowApprovedFooterState] = useState(false);

    const setShowApprovedFooter = useCallback((show: boolean) => {
        setShowApprovedFooterState(show);
    }, []);

    return {
        showApprovedFooter,
        setShowApprovedFooter,
    };
}

export const ReviewingFooterStore = createStore(useReviewingFooter);

export type ReviewingFooterStoreValue = ReturnType<typeof useReviewingFooter>;
